export const GROUP_BY_MODE = 'group_by';
export const ADD_COLUMNS_MODE = 'add_columns';
